export default __webpack_public_path__ + "static/media/bronze.fcdcb78c.svg";